import React from 'react';
import { useHeadingStyles } from './hooks/useHeadingStyles.js';

const Heading = ({ className = '', children, level = '1', tagName, ...props }) => {
    const styles = useHeadingStyles(level);
    const Component = tagName
        ? tagName
        : `h${level}`;
    return (React.createElement(Component, { className: [styles, className].join(' '), ...props }, children));
};

export { Heading };
//# sourceMappingURL=Heading.js.map
